module.exports = __webpack_public_path__ + "dingbeauty-build/img/store-default-Image@2x.bf8defb4.png";